import React from 'react';
import { Link } from 'react-router-dom';
import { RESPONSABLE } from '../data/legal';

/**
 * El pie de las dos páginas legales.
 *
 * Estaba escrito dos veces, una en cada página, con estilos inline y el año
 * puesto a mano ("© 2025"). Además cada documento sólo enlazaba a sí mismo, así
 * que para pasar de la privacidad a los términos había que volver e ir de nuevo
 * — y son documentos que se leen de a pares.
 *
 * El año sale del reloj: acá sí corresponde, porque un aviso de copyright dice
 * el año en curso, a diferencia de la fecha de actualización del documento, que
 * es un dato fijo y vive en data/legal.js.
 */
const PieLegal = () => (
  <footer className="legal-pie">
    <p>
      <Link to="/legal/terms">Términos y Condiciones</Link>
      {' · '}
      <Link to="/legal/privacy">Política de Privacidad</Link>
    </p>
    <p>© {new Date().getFullYear()} Aturno — {RESPONSABLE.nombre}, {RESPONSABLE.domicilio}</p>
    <p>
      Consultas: <a href={`mailto:${RESPONSABLE.email}`}>{RESPONSABLE.email}</a>
    </p>
  </footer>
);

export default PieLegal;
